(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["monet-collection-film"] && !Shopify.designMode) return;
  try {
    

function initializeMonetCollectionFilms() {
  document.querySelectorAll('[data-monet-collection-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetCollectionFilms, {once:true});
} else {
  initializeMonetCollectionFilms();
}
document.addEventListener('shopify:section:load', initializeMonetCollectionFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-la-mer-film"] && !Shopify.designMode) return;
  try {
    
function initializeMonetLaMerFilms() {
  document.querySelectorAll('[data-monet-la-mer-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetLaMerFilms, {once:true});
} else {
  initializeMonetLaMerFilms();
}
document.addEventListener('shopify:section:load', initializeMonetLaMerFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-signature-film"] && !Shopify.designMode) return;
  try {
    
function initializeMonetSignatureFilms() {
  document.querySelectorAll('[data-monet-signature-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetSignatureFilms, {once:true});
} else {
  initializeMonetSignatureFilms();
}
document.addEventListener('shopify:section:load', initializeMonetSignatureFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-signature-gallery"] && !Shopify.designMode) return;
  try {
    
function initializeMonetSignatureGalleries() {
  document.querySelectorAll('[data-monet-signature-gallery]').forEach((root) => {
    if (root.dataset.galleryInitialized) return;
    root.dataset.galleryInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const grid = root.querySelector('[data-gallery-grid]');
    const cards = Array.from(root.querySelectorAll('[data-gallery-card]'));
    const controls = root.querySelector('[data-gallery-controls]');
    const previous = controls.querySelector('[data-gallery-previous]');
    const next = controls.querySelector('[data-gallery-next]');
    const progress = controls.querySelector('[data-gallery-progress]');
    let current = 0;
    let queued = false;
    const updateNavigation = () => {
      controls.hidden = !portrait.matches || cards.length < 2;
      if (cards.length) {
        const firstOffset = cards[0].offsetLeft;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const candidate = Math.abs(card.offsetLeft - firstOffset - grid.scrollLeft);
          if (candidate < distance) { distance = candidate; current = index; }
        });
      }
      previous.disabled = current === 0;
      next.disabled = current === cards.length - 1;
      progress.textContent = progress.dataset.counterTemplate.replace('__CURRENT__', String(current + 1));
    };
    const goToCard = (index) => {
      if (!cards[index]) return;
      grid.scrollTo({left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => goToCard(current - 1));
    next.addEventListener('click', () => goToCard(current + 1));
    grid.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { updateNavigation(); queued = false; });
    }, {passive:true});
    portrait.addEventListener('change', updateNavigation);
    cards.forEach((card) => {
      const video = card.querySelector('video');
      const button = card.querySelector('.monet-signature-gallery__toggle');
      if (!video || !button) return;
      let visible = false;
      let pausedByUser = false;
      let allowMotion = !reducedMotion.matches;
      const updateButton = () => {
        const playing = !video.paused;
        button.dataset.playing = String(playing);
        button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      };
      const syncPlayback = () => {
        if (visible && !document.hidden && !pausedByUser && allowMotion) video.play().catch(updateButton);
        else video.pause();
      };
      const selectSource = () => {
        const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        if (video.getAttribute('src') === src) return;
        video.poster = poster;
        video.src = src;
        video.muted = true;
        video.load();
        syncPlayback();
      };
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      video.addEventListener('loadedmetadata', syncPlayback);
      button.addEventListener('click', () => {
        if (video.paused) { pausedByUser = false; allowMotion = true; video.play().catch(updateButton); }
        else { pausedByUser = true; video.pause(); }
      });
      portrait.addEventListener('change', selectSource);
      reducedMotion.addEventListener('change', () => { allowMotion = !reducedMotion.matches; syncPlayback(); });
      document.addEventListener('visibilitychange', syncPlayback);
      const observer = new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .4;
        syncPlayback();
      }, {threshold:[0,.4,1]});
      observer.observe(video);
      selectSource();
      button.hidden = false;
      updateButton();
    });
    updateNavigation();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMonetSignatureGalleries, {once:true});
else initializeMonetSignatureGalleries();
document.addEventListener('shopify:section:load', initializeMonetSignatureGalleries);

  } catch(e) { console.error(e); }
})();
})();
